// extracted by mini-css-extract-plugin
export var registerPage = "register-form-module--register-page--Iu0D5";
export var thankyouPage = "register-form-module--thankyou-page--Rg0jZ";
export var registerFormWrapper = "register-form-module--register-form-wrapper--LR1mH";
export var registerSummaryWrapper = "register-form-module--register-summary-wrapper--Kc7k8";
export var inputTwoCol = "register-form-module--input-two-col--CwlNU";